/**
 * Build a Creative Brief page path: /briefs/{uuid}/{number}[/suffix]
 *
 * @param {{ id?: string, number?: number|string|null }|string|null} briefOrId
 * @param {number|string|null|undefined} number
 * @param {string} [suffix]
 * @returns {string}
 */
export function briefPath(briefOrId, number, suffix = '') {
  let id = '';
  let num = number;

  if (briefOrId && typeof briefOrId === 'object') {
    id = briefOrId.id != null ? String(briefOrId.id) : '';
    if (num == null || num === '') {
      num = briefOrId.number;
    }
  } else if (briefOrId != null) {
    id = String(briefOrId);
  }

  if (!id) {
    return '/briefs';
  }

  const tail = suffix ? `/${String(suffix).replace(/^\/+/, '')}` : '';
  if (num != null && num !== '') {
    return `/briefs/${id}/${num}${tail}`;
  }

  return `/briefs/${id}${tail}`;
}
